import React, { useState, useEffect } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
// import * as wjCore from '@mescius/wijmo'
import * as wjGrid from '@mescius/wijmo.grid'
import * as wjMultiRow from '@mescius/wijmo.react.grid.multirow'
import { FlexGridFilter } from '@mescius/wijmo.grid.filter'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import { Modal } from '@material-ui/core'
import customContextMenu from '../../wijmo/customContextMenu'
import { KeyAction } from '@mescius/wijmo.grid'
import { CollectionViewNavigator } from '@mescius/wijmo.react.input'
import colElements from '../../wijmo/columnElements'
import MyRestCollectionView from '../../wijmo/MyRestCollectionView'
import { idPresentation, contractTypePresentation } from '../../utility'
import { useStyles } from '../MaterialUiModal'
import Transit from '../Transit'
import BootstrapAlert from '../element/BootstrapAlert'

function colLayout (isShopro) {
  const colBase = {
    cssClassAll: 'wj-style-basic',
    isReadOnly: true,
    width: 110
  }
  const idCellTemp = (ctx) => `<div class="zero-padding">${idPresentation(ctx.value)}</div>`
  const contractTypeDataMap = new wjGrid.DataMap(
    [0, 1, 2, 3].map((contractType) => {
      return { value: contractType, text: contractTypePresentation(contractType) }
    }),
    'value',
    'text'
  )

  const layout = [
    isShopro
      ? {
          colspan: 1,
          cells: [
            {
              ...colBase,
              binding: 'sp_memo',
              header: 'ShoPro社内メモ',
              rowspan: 2,
              cssClassAll: 'wj-style-basic-input',
              align: 'center',
              width: 80,
              isReadOnly: false,
              maxLength: 40,
              wordWrap: true
            }
          ]
        }
      : null,
    {
      colspan: 1,
      cells: [
        {
          ...colBase,
          binding: 'id',
          header: '申請ID',
          align: 'left',
          cellTemplate: (ctx) => `<a href="${ctx.item.uri}">${idPresentation(ctx.value)}</a>`,
          width: 90,
          rowspan: 2
        }
      ]
    },
    isShopro
      ? {
          colspan: 3,
          cells: [
            { ...colBase, binding: 'applied_at', format: 'd', header: '申請日時', width: 160 },
            { ...colBase, binding: 'approver_name', header: '承認者', width: 110 },
            { ...colBase, binding: 'sales_month', header: '売上月', width: 100 },
            { ...colBase, binding: 'completed_at', header: '最終承認日時', width: 160 },
            { ...colBase, binding: 'wf_state', header: 'ステータス', width: 110 },
            { ...colBase, binding: 'character.group.group_name', header: 'グループ', width: 100 }
          ]
        }
      : {
          colspan: 1,
          cells: [
            { ...colBase, binding: 'applied_at', header: '申請日時', width: 150 },
            { ...colBase, binding: 'wf_state', header: 'ステータス', width: 150 }
          ]
        },
    isShopro
      ? {
          colspan: 2,
          cells: [
            { ...colBase, binding: 'sp_user.department.name', header: '事業部', width: 100 },
            { ...colBase, binding: 'sp_user.division.name', header: '課', width: 100 },
            { ...colBase, binding: 'sp_user.name', header: 'ShoPro担当者', width: 100 },
            { ...colBase, binding: 'sp_user.position_comment', header: '担当者属性', width: 100 }
          ]
        }
      : null,
    isShopro
      ? {
          colspan: 1,
          cells: [
            { ...colBase, binding: 'user.company.name', header: '会社名', width: 150 },
            { ...colBase, binding: 'user.name', header: '申請者名', width: 150 }
          ]
        }
      : null,
    {
      colspan: 1,
      cells: [
        { ...colBase, binding: 'character.title', header: 'キャラクター', width: 150 },
        { ...colBase, binding: 'contract_type', header: '契約方式', width: 150, dataMap: contractTypeDataMap, align: 'left' }
      ]
    },
    {
      colspan: 3,
      cells: [
        { ...colBase, binding: 'period_from', header: '契約開始日', width: 110 },
        { ...colElements.royality_total, binding: 'royality', width: 100 },
        { ...colBase, binding: 'item_info', header: 'アイテム', width: 150, align: 'left' },
        { ...colBase, binding: 'period_to', header: '契約終了日', width: 110 },
        { ...colElements.rate_decimal, width: 100 },
        { ...colBase, binding: 'recouped_at', header: 'リクープ日時', width: 150 }
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colBase, binding: 'initial_trade.preferred_day', header: '証紙受取希望日', width: 100 },
        { ...colBase, binding: 'initial_trade.stamp_comment', header: '受け取り方法', width: 100 }
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colBase, binding: 'is_proxy', header: '代理', width: 60, rowspan: 2, align: 'center' }
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colBase, binding: 'coop_con_id', header: '契約ID', align: 'left', width: 130 },
        { ...colBase, binding: 'coop_trd_id', header: '取引ID', align: 'left', width: 130 }
      ]
    },
    isShopro
      ? {
          colspan: 1,
          cells: [
            { ...colBase, binding: 'user.company_id', header: '会社ID', align: 'left', cellTemplate: idCellTemp },
            { ...colBase, binding: 'user_id', header: '申請者ID', align: 'left', cellTemplate: idCellTemp }
          ]
        }
      : null,
    {
      colspan: 1,
      cells: [
        {
          ...colBase,
          binding: 'uri',
          header: ' ',
          rowspan: 2,
          align: 'center',
          width: 80,
          cellTemplate: (ctx) => {
            return `<a href="${ctx.text}" class="btn bg-theme-success py-0">詳細</a>`
          },
          allowSorting: false
        }
      ]
    },
    isShopro
      ? null
      : {
          colspan: 1,
          cells: [
            {
              ...colBase,
              binding: 'create_trade_uri',
              header: ' ',
              rowspan: 2,
              align: 'center',
              width: 120,
              cellTemplate: (ctx) => {
                return ctx.text ? `<a href="${ctx.text}" class="btn bg-theme-success py-0">製造申請へ</a>` : ''
              },
              allowSorting: false
            }
          ]
        }
  ].filter((col) => col)
  return {
    def: layout,
    frozenColumns: 0
  }
}

function getWfState (workflow, isShopro) {
  if (isShopro) {
    if (workflow) {
      if (workflow.is_returned) {
        return '差戻し'
      } else if (workflow.is_approver) {
        return '未承認'
      } else if (workflow.is_approved) {
        return '承認済'
      } else {
        return '承認待ち'
      }
    } else {
      return 'ルート未設定'
    }
  } else {
    if (workflow) {
      if (workflow.is_approved) {
        return '承認済'
      } else if (workflow.is_returned) {
        return '差戻し'
      } else {
        return '確認中'
      }
    } else {
      return '確認中'
    }
  }
}

function setWfStateStyle (cell, isShopro) {
  if (isShopro) {
    switch (cell.innerHTML) {
      case 'ルート未設定':
        cell.classList.add('bg-default')
        break
      case '未承認':
        cell.classList.add('bg-default')
        break
      case '承認待ち':
        cell.classList.add('bg-default')
        break
      case '承認済':
        cell.classList.add('bg-default')
        break
      case '差戻し':
        cell.classList.add('bg-danger', 'text-white')
        break
      default:
        break
    }
  } else {
    switch (cell.innerHTML) {
      case '承認済':
        cell.classList.add('bg-default')
        break
      case '確認中':
        cell.classList.add('bg-default')
        break
      case '差戻し':
        cell.classList.add('bg-danger', 'text-white')
        break
      default:
        break
    }
  }
}

const setContractProperties = (isShopro) => (contract) => {
  contract.id = `${contract.id}`
  if (contract.character.is_default) {
    contract.character.title = '★' + contract.character_name_free
  }
  contract.character_title = contract.character.title
  contract.contract_type_str = contractTypePresentation(contract.contract_type)
  contract.rate_decimal = Number(contract.rate) * 0.01
  contract.wf_state = getWfState(contract.workflow, isShopro)
  contract.is_proxy = contract.proxy_sp_user_id ? '〇' : ''

  if (contract.contract_type === 1) {
    // アイテム個別契約のみ
    if (contract.items) {
      // 使用料を計算
      contract.royality = contract.items
        .map((item) => item.royality_prod)
        .reduce((prev, current) => prev + current, 0)
      // アイテム情報を作成
      if (contract.items.length === 1) {
        contract.item_info = `1点（${contract.items[0].name}）`
      } else {
        contract.item_info = `${contract.items.length}点（${contract.items[0].name} 他）`
      }
    }
  } else {
    contract.item_info = '-'
  }

  if (contract.contract_type !== 2) {
    contract.recouped_at = '-'
  }

  return contract
}

let collectionView = null

export default function ApplicationListContract (props) {
  const params = new URL(location.href).searchParams
  const [layoutDef] = useState(colLayout(props.isShopro))
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [exportProgress, setExportProgress] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const styles = useStyles()

  if (!collectionView) {
    collectionView = new MyRestCollectionView(
      props.url,
      params,
      setContractProperties(props.isShopro),
      props.query,
      props.isShopro ? props.editUrl : '#',
      props.isShopro ? (item) => { return { id: item.id, sp_memo: item.sp_memo, updated_at: item.updated_at } } : null
    )
  }

  // インポート/エクスポート時のテーブルを定義
  const tableFormat =
  props.isShopro
    ? [
        { field: 'id', text: '申請ID', type: 'string', isEditable: false },
        { field: 'applied_at', text: '申請日時', type: 'string', isEditable: false },
        { field: 'completed_at', text: '最終承認日時', type: 'string', isEditable: false },
        { field: 'approver_name', text: '承認者', type: 'string', isEditable: false },
        { field: 'wf_state', text: 'ステータス', type: 'string', isEditable: false },
        { field: 'sales_month', text: '売上月', type: 'string', isEditable: false },
        { field: 'character.group.group_name', text: 'グループ', type: 'string', isEditable: false },
        { field: 'sp_user.department.name', text: '事業部', type: 'string', isEditable: false },
        { field: 'sp_user.division.name', text: '課', type: 'string', isEditable: false },
        { field: 'sp_user.name', text: 'ShoPro担当者', type: 'string', isEditable: false },
        { field: 'sp_user.position_comment', text: '担当者属性', type: 'string', isEditable: false },
        { field: 'coop_con_id', text: '契約ID', type: 'string', isEditable: false },
        { field: 'coop_trd_id', text: '取引ID', type: 'string', isEditable: false },
        { field: 'user.company_id', text: '会社ID', type: 'string', isEditable: false },
        { field: 'user.company.name', text: '会社名', type: 'string', isEditable: false },
        { field: 'user_id', text: '申請者ID', type: 'string', isEditable: false },
        { field: 'user.name', text: '申請者名', type: 'string', isEditable: false },
        { field: 'character.title', text: 'キャラクター', type: 'string', isEditable: false },
        { field: 'contract_type_str', text: '契約方式', type: 'string', isEditable: false },
        { field: 'period_from', text: '契約開始日', type: 'string', isEditable: false },
        { field: 'period_to', text: '契約終了日', type: 'string', isEditable: false },
        { field: 'royality', text: '使用料', type: 'number', isEditable: false },
        { field: 'rate_decimal', text: '料率', type: 'number', isEditable: false },
        { field: 'item_info', text: 'アイテム', type: 'string', isEditable: false },
        { field: 'recouped_at', text: 'リクープ日時', type: 'string', isEditable: false },
        { field: 'initial_trade.preferred_day', text: '証紙受取希望日', type: 'string', isEditable: false },
        { field: 'initial_trade.stamp_comment', text: '受け取り方法', type: 'string', isEditable: false },
        { field: 'is_proxy', text: '代理', type: 'string', isEditable: false },
        { field: 'sp_memo', text: 'メモ', type: 'string', isEditable: false }
      ]
    : [
        { field: 'id', text: '申請ID', type: 'string', isEditable: false },
        { field: 'applied_at', text: '申請日時', type: 'string', isEditable: false },
        { field: 'wf_state', text: 'ステータス', type: 'string', isEditable: false },
        { field: 'user.company.name', text: '会社名', type: 'string', isEditable: false },
        { field: 'sp_user.name', text: 'ShoPro担当者名', type: 'string', isEditable: false },
        { field: 'coop_con_id', text: '契約ID', type: 'string', isEditable: false },
        { field: 'coop_trd_id', text: '取引ID', type: 'string', isEditable: false },
        { field: 'character_title', text: 'キャラクター', type: 'string', isEditable: false },
        { field: 'contract_type_str', text: '契約方式', type: 'string', isEditable: false },
        { field: 'period_from', text: '契約開始日', type: 'string', isEditable: false },
        { field: 'period_to', text: '契約終了日', type: 'string', isEditable: false },
        { field: 'royality', text: '使用料', type: 'number', isEditable: false },
        { field: 'rate_decimal', text: '料率', type: 'number', isEditable: false },
        { field: 'item_info', text: 'アイテム', type: 'string', isEditable: false },
        { field: 'recouped_at', text: 'リクープ日時', type: 'string', isEditable: false }
      ]

  useEffect(() => {
  }, [])

  const initializeGrid = (flex) => {
    flex.collectionView.loading.addHandler((s, e) => setLoading(true))
    flex.collectionView.loaded.addHandler((s, e) => setLoading(false))
    flex.collectionView.setErrorMessage = setErrorMessage

    flex.formatItem.addHandler((s, e) => {
      if (e.panel === s.columnHeaders) return
      const col = flex.getBindingColumn(e.panel, e.row, e.col)

      if (col.binding === 'contract_type') {
        switch (e.cell.innerHTML) {
          case 'アイテム個別':
            e.cell.classList.add('bg-default')
            break
          case 'グロス':
            e.cell.classList.add('bg-default')
            break
          case 'その他':
            e.cell.classList.add('bg-default')
            break
          case 'クロスリクープ':
            e.cell.classList.add('bg-default')
            break
          default:
            break
        }
      }
      if (col.binding === 'wf_state') {
        setWfStateStyle(e.cell, props.isShopro)
      }
    })

    flex.cellEditEnding.addHandler((s, e) => {
      const col = s.columns[e.col]
      if (col.binding === 'sp_memo') {
        if (!s.activeEditor.value) {
          // RestCollectionViewの仕様で空文字にすると更新リクエストが発生しないため、空白1字に設定する
          s.activeEditor.value = ' '
        }
        if (!window.confirm('メモを更新しますか？')) {
          e.cancel = true
        }
      }
    })

    // フィルター設定
    const _filter = new FlexGridFilter(flex)
    _filter.filterColumns = layoutDef.def.flat()
      .map((col) => col.cells).flat()
      .map((cell) => cell.binding)
      .filter((binding) => binding !== 'uri')

    flex.tableFormat = tableFormat

    // コンテキストメニュー設定
    customContextMenu(flex)
  }

  const onPageLoaded = (page) => {
    setExportProgress(`${Math.round(page / collectionView.pageCount * 1000) / 10}%`)
  }

  const onModalClosed = () => {
    setModalOpen(false)
    setExportProgress(null)
  }

  return (
    <div className="d-inline-block w-100">
      {props.isShopro && (
        <div className="w-100 text-right">
          <button type="button" className="btn bg-theme-primary mb-2" onClick={() => setModalOpen(true)}>
            すべてエクスポート
          </button>
        </div>
      )}
      {errorMessage && (
        <BootstrapAlert class='danger'>
          <div>{errorMessage}</div>
        </BootstrapAlert>
      )}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: collectionView.pageCount > 1 ? '500px' : undefined }}>
        {Transit({
          inTransit: loading,
          element: (
            <wjMultiRow.MultiRow showMarquee={true} stickyHeaders={true} itemsSource={collectionView} layoutDefinition={layoutDef.def}
              frozenColumns={layoutDef.frozenColumns} keyActionTab={KeyAction.Cycle} initialized={initializeGrid}
              style={{ maxHeight: '500px' }}>
            </wjMultiRow.MultiRow>
          )
        })}
      </div>
      <div className="w-100 text-center pt-2">
        <CollectionViewNavigator cv={collectionView} byPage={true} repeatButtons={false} isDisabled={loading}/>
      </div>
      <Modal
        className={styles.modal}
        open={modalOpen}
        onClose={() => onModalClosed()}>
        <div className={styles.paper}>
          <h2>エクスポート確認</h2>
          <hr />
          {exportProgress === null
            ? (
            <p>
              他のページを含むすべての新規契約申請をExcelファイルにエクスポートします。<br/>
              この処理は時間がかかる場合があります。<br/>
              実行しますか？
            </p>
              )
            : (
            <p>
              {exportProgress === '100%' ? 'エクスポートが完了しました。' : `ファイルを作成しています（${exportProgress}）。`}
            </p>
              )}
          <hr />
          <div className="row theme-3">
            <div className="col-6">
              <button type='button' className='btn btn-outline-secondary' onClick={() => onModalClosed()}>
                キャンセル
              </button>
            </div>
            <div className="col-6 text-right">
              <button type="button" className="btn bg-8" disabled={exportProgress !== null}
                onClick={() => {
                  onPageLoaded(0)
                  collectionView.exportAllItems(tableFormat, onPageLoaded)
                }}>
                実行
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

ApplicationListContract.propTypes = {
  url: PropTypes.string,
  isShopro: PropTypes.bool,
  query: PropTypes.object,
  editUrl: PropTypes.string
}

ApplicationListContract.defaultProps = {
  isShopro: false,
  query: {},
  editUrl: '#'
}

const idList = ['#application-list-contract']
idList.map((id) => {
  const elem = $(id)
  if (elem.length) {
    const props = elem.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
    ReactDOM.render(<ApplicationListContract {...props}/>, elem[0])

    Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
      elem.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
      return 0
    })
  }
  return 0
})
